document.addEventListener('DOMContentLoaded', () => {
    const cartDrawerContainer = document.querySelector('.cart-drawer-slideshow-wrapper');
    let currentIndex = 0;
    let autoSlideInterval;
    let totalSlides;
    let realSlides;
    let removedIndexes = [];
    let isSliding = false;
    let isAdding = false;
    let isDropOpen = false;
    let cart = document.querySelector('cart-drawer');
    const slidesContainer = document.querySelector('.cart-drawer-slides');

    var prevButton = document.getElementById('cart-drawer-prev-button');
    var nextButton = document.getElementById('cart-drawer-next-button');
    setupTouch();
    update();
    function update() {
      const slideClones = document.querySelector('.cart-drawer-slides-clones');
      if (slideClones){
        realSlides = Array.from(slideClones.children);
        totalSlides = realSlides.length;
      } else {
        console.error("No slides where there should be.");
        realSlides = [];
        totalSlides = 0;
      }


    }

    function getCurrentIndex() {
        if (totalSlides == 0) {
            return [];
        }
        if (totalSlides == 1) {
            return [0];
        }

        return [totalSlides % (currentIndex - 1), currentIndex, (totalSlides % (currentIndex + 1))]

    }

    function setNextList() {
        if (totalSlides == 0) {
            return [];
        }
        if (totalSlides == 1) {
            return [0];
        }

        currentIndex = (currentIndex + totalSlides + 1) % totalSlides
        const nextIndex = (currentIndex + totalSlides - 1) % totalSlides

        return [nextIndex, currentIndex]

    }

    function setPreviousList() {

        if (totalSlides == 0) {
            return [];
        }
        if (totalSlides == 1) {
            return [0];
        }

        currentIndex = (currentIndex + totalSlides - 1) % totalSlides
        const nextIndex = (currentIndex + totalSlides + 1) % totalSlides

        return [currentIndex, nextIndex]

    }

    function showNextSlide() {
        if (!totalSlides || totalSlides == 0 || totalSlides == 1) {
            return;
        }

        const slides = document.querySelector('.cart-drawer-slides');
        if (!slides){
          return;
        }
        slides.style.transition = `none`;
        slides.style.transform = `none`;
        void slides.offsetHeight;
        const indexList = setNextList();


        while (slides.firstChild) {
            slides.removeChild(slides.firstChild);
        }


        indexList.forEach((index) => {
          const realSlide = realSlides[index];
          if (realSlide){
            slides.appendChild(realSlide.cloneNode(true));
          }
        });


        isSliding = true;

        function transitionEndHandler() {

            isSliding = false;
            slides.removeEventListener('transitionend', transitionEndHandler); // Clean up after itself
        }

        // Remove existing listener to avoid duplicates
        slides.removeEventListener('transitionend', transitionEndHandler);
        // Add the listener again
        slides.addEventListener('transitionend', transitionEndHandler);


        slides.style.transition = 'transform 0.5s ease-in-out';
        slides.style.transform = 'translateX(-100%)';
        setupDropdownState();

    }

    function showPrevSlide() {

        if (!totalSlides || totalSlides == 0 || totalSlides == 1) {
            return;
        }
      
        const slides = document.querySelector('.cart-drawer-slides');
        if (!slides){
          return;
        }
        slides.style.transition = `none`;
        slides.style.transform = `translateX(-100%)`;
        void slides.offsetHeight;

        const indexList = setPreviousList();


        while (slides.firstChild) {
            slides.removeChild(slides.firstChild);
        }


        indexList.forEach((index) => {

          
          const realSlide = realSlides[index];
          if (realSlide){
            slides.appendChild(realSlide.cloneNode(true));
          }
        });


        isSliding = true;

        function transitionEndHandler() {

            isSliding = false;
            slides.removeEventListener('transitionend', transitionEndHandler); // Clean up after itself
        }

        // Remove existing listener to avoid duplicates
        slides.removeEventListener('transitionend', transitionEndHandler);
        // Add the listener again
        slides.addEventListener('transitionend', transitionEndHandler);


        slides.style.transition = 'transform 0.5s ease-in-out';

        slides.style.transform = 'translateX(0%)';
        setupDropdownState();

    }

    resetAutoSlide();

    subscribe(PUB_SUB_EVENTS.drawerCartUpdate, (event) => {
        update();
    setupTouch();
        
    });

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        update();
    setupTouch();
        
    });

    function resetAutoSlide() {
        clearInterval(autoSlideInterval);
        autoSlideInterval = setInterval(() => {
          if (!isAdding && !isDropOpen){
            showNextSlide();
          }
        }, 5000);
    }

    function onNext() {
        if (!isSliding) {
            resetAutoSlide();
            showNextSlide();
        }
    }

    function onPrevious() {
        if (!isSliding) {
            resetAutoSlide();
            showPrevSlide();
        }
    }

    function setupTouch(){
      setupScroll();
      setupDropdownState();
    }

    function setupDropdownState() {
      const variantSelectors = document.querySelectorAll('.variant-selector');
      isDropOpen = false;
      variantSelectors.forEach(selector => {
          // Detect when the dropdown is opened
          selector.addEventListener('focus', () => {
            isDropOpen = true;
          });
  
          // Detect when the dropdown is closed
          selector.addEventListener('blur', () => {
              isDropOpen = false;
          });
      });
    }

    function setupScroll() {
        const slideContainer = document.querySelector('.cart-drawer-slides');
        if(!slideContainer){
          console.error("drawer missing !");
          return;
        }
        let startX;
        let startScroll;
        let isMoving = false; // This flag will track if a move action is detected

        slideContainer.addEventListener('touchstart', function(e) {
            startX = e.touches[0].pageX;
            startScroll = slideContainer.scrollLeft;
        }, {
            passive: true
        });

        slideContainer.addEventListener('touchmove', function(e) {
            const currentX = e.touches[0].pageX;
            const diffX = currentX - startX;

            if (Math.abs(diffX) > 10) { // Threshold to decide when a move is significant
                isMoving = true;
                e.preventDefault(); // Prevent scrolling and links only when actually moving
                slideContainer.scrollLeft = startScroll - diffX;
            }
        }, {
            passive: false
        });

        slideContainer.addEventListener('touchend', function(e) {
            if (isMoving) {
                const endX = e.changedTouches[0].pageX;
                const diffX = endX - startX;

                if (diffX > 50) { // Threshold for swipe recognition
                    slideLeft();
                } else if (diffX < -50) {
                    slideRight();
                }

                isMoving = false; // Reset the moving flag
                e.preventDefault(); // Prevent click events if a move occurred
            }
        });


        function slideLeft() {
            onPrevious();
        }

        function slideRight() {
            onNext();
        }
    }


    function updateVariantDetails(product, variantId) {
        const selectedVariant = product.variants.find(variant => variant.id == variantId);
    
        if (selectedVariant) {
            // Update price
            const priceElement = document.getElementById(`upsell-product-price-${product.id}`);
            if (priceElement) {
                priceElement.textContent = selectedVariant.price;
            }
    
            // Update image
            const imageElement = document.getElementById(`upsell-product-image-${product.id}`);
            if (imageElement && selectedVariant.featured_image) {
                imageElement.src = selectedVariant.featured_image.src;
            }
    
            // Update Add to Cart button with new variant ID
            const addToCartButton = document.querySelector(`.cart-drawer-add-to-cart-button[data-product-id="${product.id}"]`);
            if (addToCartButton) {
                addToCartButton.setAttribute('data-variant-id', selectedVariant.id);
            }
        }
    }
  
    function addToCart(productId, buttonElement) {
      isAdding = true;
        // Disable the button to prevent multiple clicks
        buttonElement.setAttribute('aria-disabled', 'true');

        // Get references to the button text and loader elements
        var buttonText = buttonElement.querySelector('.button-text');
        var loader = buttonElement.querySelector('.loader');

        // Hide the button text and show the loader
        buttonText.style.display = 'none';
        loader.style.display = 'inline-block';


      var config;
      if (cart){
       config= {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              id: productId,
              quantity: 1,
              tag: 'winner_upsell',
              sections: cart.getSectionsToRender().map((section) => section.id),
              sections_url: window.location.pathname,
            }),
        };
        cart.setActiveElement(document.activeElement);
      } else {
        config= {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({
                id: productId,
                quantity: 1
            }),
        };
      }

        // Perform the fetch operation
        fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    return;
                } else {
                    if (response.status) {
                        publish(PUB_SUB_EVENTS.cartError, {
                            source: 'product-form',
                            productVariantId: productId,
                            errors: response.errors || response.description,
                            message: response.message,
                        });
                        this.handleErrorMessage(response.description);

                        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                        if (!soldOutMessage) return;
                        this.submitButtonText.classList.add('hidden');
                        soldOutMessage.classList.remove('hidden');
                        this.error = true;
                        return;
                    } else if (!cart) {
                        window.location = window.routes.cart_url;
                        return;
                    }

                    if (!this.error) {
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                            source: 'product-form',
                            cartData: response,
                        });
                    }

                    this.error = false;

                    const slide = buttonElement.closest('.cart-drawer-slide');
                    const productId = slide.getAttribute('data-product-id');



                  cart.renderContents(response);
                }
            })
            .catch((error) => {
                // Handle fetch errors
                console.error(error);
            })
            .finally(() => {
                // Re-enable the button
                buttonElement.removeAttribute('aria-disabled');

                // Restore the button text and hide the loader
                buttonText.style.display = 'inline-block';
                loader.style.display = 'none';
              isAdding = false;
            });
    }

    document.body.addEventListener('change', function(event) {
        const dropdown = event.target.closest('.variant-selector');
        if (dropdown) {
            // Get the parent slide
            const cartSlide = dropdown.closest('.cart-drawer-slide');
            if (!cartSlide) return;
    
            // Extract product ID from the slide
            const productId = cartSlide.getAttribute('data-product-id');
    
            // Get the selected option and its attributes
            const selectedOption = dropdown.options[dropdown.selectedIndex];
            const variantId = selectedOption.value;
            const price = selectedOption.getAttribute('data-price');
            const image = selectedOption.getAttribute('data-image');
            const title = selectedOption.getAttribute('data-title');
    
            // Update price in the slide
            const priceElement = cartSlide.querySelector(`#upsell-product-price`);
            if (priceElement) {
                priceElement.textContent = price;
            }
    
            // Update image in the slide
            const imageElement = cartSlide.querySelector(`#upsell-product-image`);
            if (imageElement) {
                imageElement.src = image;
            }
    
            // Update Add to Cart button's variant ID
            const addToCartButton = cartSlide.querySelector(`.cart-drawer-add-to-cart-button`);
            if (addToCartButton) {
                addToCartButton.setAttribute('data-variant-id', variantId);
            }
    
            // (Optional) Update other elements like title if needed
            const titleElement = cartSlide.querySelector(`#upsell-product-title`);
            if (titleElement) {
                titleElement.textContent = title;
            }
          
          
          realSlides.forEach((realSlide, index) => {
            if (realSlide.getAttribute('data-product-id') == productId) {
                realSlides[index] = cartSlide;
              return;
            }
          });
        }
    });


    document.body.addEventListener('click', function(event) {
        const button = event.target.closest('.cart-drawer-add-to-cart-button');
        if (button) {
            const productId = button.getAttribute('data-variant-id');
            if (productId) {
                addToCart(productId, button);
            }
        }
    });

    document.body.addEventListener('click', function(event) {
        if (event.target.closest('.cart-drawer-prev')) {
            onPrevious();
        } else if (event.target.closest('.cart-drawer-next')) {
            onNext();
        }
    });
});